import axios from "axios";

import env from "../environments";

export const addPermission = async ({
	userId,
	teamId,
	permission,
}: {
	userId?: string;
	teamId?: string;
	permission: string;
}) => {
	await axios.post(`${env.apiUrl}/permissions`, { userId, teamId, permission });

	return;
};

export const deletePermission = async ({ permissionId }: { permissionId: string }) => {
	await axios.delete(`${env.apiUrl}/permissions/${permissionId}`);

	return;
};
